import Link from 'next/link'
import React from 'react'

const airconServiceData = [
  {
    title: 'General Service',
    desc: 'Thorough general cleaning of aircon units to ensure optimal performance and hygiene.',
    href: '/sg/aircon-servicing-singapore/cleaning-maintenance-service',
    icon: '🧾',
  },
  {
    title: 'Chemical Wash',
    desc: 'Recommended for heavily clogged FCUs or leaking aircons. Deeper internal cleaning.',
    href: '/sg/aircon-servicing-singapore/aircon-chemical-wash-and-overhaul',
    icon: '🧼',
  },
  {
    title: 'Gas Top-up',
    desc: 'Gas top-up for R22, R410A & R32 refrigerants to restore cooling efficiency.',
    href: '/sg/aircon-servicing-singapore/aircon-gas-top-up',
    icon: '❄️',
  },
  {
    title: 'Repair',
    desc: 'Fix water leaks, gas leaks, fan motor problems, compressor faults, and more.',
    href: '/sg/aircon-servicing-singapore/aircon-repair',
    icon: '🛠️',
  },
  {
    title: 'Annual Package',
    desc: 'Quarterly servicing under one affordable plan. Ideal for tenants and landlords.',
    href: '/sg/aircon-servicing-singapore/annual-package',
    icon: '📅',
  },
  {
    title: 'Condenser Cleaning',
    desc: 'Deep cleaning of compressor & condenser coils for better system health.',
    href: '/sg/aircon-servicing-singapore/aircon-condenser-cleaning',
    icon: '🌀',
  },
  {
    title: 'HVAC Installation',
    desc: 'Professional installation of all types of air conditioning units.',
    href: '/sg/aircon-servicing-singapore/aircon-installation',
    icon: '🔧',
  },
  {
    title: 'Cassette AC Service',
    desc: 'Specialized servicing for ceiling-mounted cassette aircon units.',
    href: '/sg/aircon-servicing-singapore/ceiling-cassette-aircon-service',
    icon: '📦',
  },
  {
    title: 'Urgent AC Service',
    desc: '24/7 emergency repair and servicing for urgent aircon issues.',
    href: '/sg/aircon-servicing-singapore/urgent-aircon-servicing',
    icon: '🚨',
  },
  {
    title: 'Parts Replacement',
    desc: 'Replace faulty parts like compressors, fan motors, sensors, and more.',
    href: '/sg/aircon-servicing-singapore/aircon-parts-replacement',
    icon: '🔄',
  },
]

export const AirconServices = () => {
  return (
    <section className="relative py-8 md:py-14 overflow-hidden">
      <div className="max-w-5xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-6">
          <h2 className="text-2xl md:text-3xl font-extrabold tracking-tight">
            Our Services
          </h2>
          <p className="mt-2 max-w-xl mx-auto text-gray-500 text-sm">
            From routine maintenance to emergency repairs — we cover every aircon need.
          </p>
        </div>

        {/* Compact link chips - keeps all 10 internal links while removing
            ~900px of card height. Descriptions move to the title attribute. */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2.5">
          {airconServiceData.map((service) => (
            <Link
              key={service.title}
              href={service.href}
              prefetch={false}
              title={service.desc}
              className="group flex items-center gap-2 rounded-xl px-3 py-2.5 bg-white border border-gray-200 hover:border-orange-200 hover:shadow-md transition-all duration-200"
            >
              <span className="text-base shrink-0">{service.icon}</span>
              <span className="text-xs sm:text-sm font-semibold text-gray-800 leading-tight group-hover:text-orange-600 transition-colors">
                {service.title}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}
